import { IGame } from "../Interfaces";

const clouds: IGame = {
  "name": "Clouds",
  "author": "Yihao",
  "time": new Date("2020-08-31T12:00:00.000Z"),
  "description": "This game resembles the gliding clouds on the sky. It is derived from the 'spaceship' pattern from the original Game of Life.",
  "refreshFrequency": 4,
  "width": 19,
  "height": 19,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true
    ],
    [
      false,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      true,
      false
    ],
    [
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      true,
      true,
      true,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      false,
      true,
      true,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 2,
  "surviveRangeUpper": 3,
  "reproductionRangeLower": 3,
  "reproductionRangeUpper": 3,
  "borderPolicy": "roll",
  "styles": [
    [
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#a2e9f2",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f5fdfd",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f1f4f4",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#f6f8f8",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      }
    ],
    [
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "#ffffff",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "#ffffff",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "#ffffff",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "#ffffff",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      }
    ]
  ]
};

export default clouds;